import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { Heading } from 'rebass'

import typography from '../../utils/typography'
import { media } from '../../utils/style'
import navigate from '../../utils/navigate'
import LinkRounded from '../../components/LinkRounded'
import { array } from 'prop-types'
import buildImageUrl from '../../../lib/media-url-maker'

import LazyLoad from 'react-lazyload'
import { lazyload } from '../../utils/style'

/*************************
 STYLES: Next / Prev
 **************************/

const PostsFrame = styled(Flex)`
  max-width: ${(props) => props.theme.content.max.width};
  position: relative;
  z-index: 1;
  a {
    text-decoration: none;
  }

  ${media.LargeScreenUp`
  overflow: visible;
  &::before {
    content:'';
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 95%;
    height: 100%;
    box-shadow:
      0 25px 25px 0px rgba(66,76,94,0.05),
      0 20px 20px 0 rgba(0,0,0,0.01);
  }
  `};
  > div:last-child > div:first-child {
    border-top: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
    ${media.MediumScreenUp`
    border-top: 0;
    `}
  }
`

const NextPrevBoc = styled(Box)`
  cursor: pointer;
  position: relative;
  background-color: white;
  transition: color 1.5s ${(props) => props.theme.ease.ease_out_expo};
  &:hover .link {
    background-color: ${(props) => props.theme.colors.blue_op10};
  }
  p {
    line-height: 1.5;
  }
`

const NextFrame = styled(NextPrevBoc)`
  order: 1;
  ${media.MediumScreenUp`
    order: 2;
  `}
`

const PreviousFrame = styled(Box)`
  cursor: pointer;
  z-index: 1;
  display: block;
  color: ${(props) => props.theme.colors.grey_light};
  padding-top: 53.081081081%;
  ${media.MediumScreenUp`
    padding-top: 0;
  `};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  background-color: ${(props) => props.theme.colors.grey};
  background-image: url(${(props) =>
    buildImageUrl({ width: 600, resource: props.image })});

  @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
    only screen and (-o-min-device-pixel-ratio: 1.3/1),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) : {
    background-image: url(${(props) =>
      buildImageUrl({ width: 1200, resource: props.image })});
  }
`

const Title = styled(Heading)`
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

const NextTitle = styled(Title)`
  color: ${(props) => props.theme.colors.grey_light};
`

const ArticleTitle = styled(Heading)`
  position: relative;
  display: block;
  z-index: 1;
  color: ${(props) => props.theme.colors.blue};
`

const FrameWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  width: 100%;
`
const Text = styled.div`
  margin-bottom: ${typography.rhythm(1)};
`

const ContentMultiCardSignpost = (props) => {
  const signposts = props.articles.map((signpost, index) => {
    const ordering = [
      [0, 1],
      [0, 2]
    ]
    const { callToActionLink } = signpost
    const internalLink = callToActionLink.startsWith('/')

    return (
      <FrameWrapper
        key={`cmcs:${signpost.subheading}:${signpost.heading}:${index}`}
      >
        <NextFrame
          order={ordering[index % ordering.length]}
          width={[1 / 1, 1 / 2]}
          pt={[50, 55]}
          pb={[50, 65]}
          pr={[15, 80]}
          pl={[25, 60]}
          onClick={() => navigate(callToActionLink)}
        >
          <NextTitle as="h6" fontSize={[2]} mb={[10]}>
            {signpost.subheading}
          </NextTitle>
          <ArticleTitle as="span" fontSize={[5, 7]} pb={20}>
            {signpost.heading}
          </ArticleTitle>
          <Text dangerouslySetInnerHTML={{ __html: signpost.sell }} />
          <LinkRounded
            to={internalLink && callToActionLink}
            href={!internalLink && callToActionLink}
          >
            {signpost.callToActionText}
          </LinkRounded>
        </NextFrame>
        <LazyLoad offset={lazyload.offset} height={350} once>
          <PreviousFrame
            onClick={() => navigate(callToActionLink)}
            order={ordering[(index + 1) % ordering.length]}
            width={[1 / 1, 1 / 2]}
            image={signpost.image}
          />
        </LazyLoad>
      </FrameWrapper>
    )
  })
  return (
    // <PostsFrame wrap as='nav' mt={[0, typography.rhythm(1)]} mb={[typography.rhythm(2), typography.rhythm(4)]} mx={['8%', 0]} >
    <PostsFrame flexWrap="wrap" as="nav" mx={['4%', 0]}>
      {signposts}
    </PostsFrame>
  )
}

ContentMultiCardSignpost.defaultProps = {
  articles: []
}
ContentMultiCardSignpost.propTypes = {
  articles: array
}
export default ContentMultiCardSignpost
